import ModelosCTeService from "@/services/ModelosCTeService";

export const modelosCTe = {
  namespaced: true,
  state: {
    modelosCTe: {},
  },
  actions: {
    getModelosCTe({ commit }, payload) {
      return ModelosCTeService.GetModelosCTe(payload).then(
        (modelosCTe) => Promise.resolve(modelosCTe),
        (error) => Promise.reject(error.response.data)
      );
    },
    postModelosCTe({ commit }, payload) {
      return ModelosCTeService.PostModelosCTe(payload).then(
        (modelosCTe) => Promise.resolve(modelosCTe),
        (error) => Promise.reject(error.response.data)
      );
    },
    putModelosCTe({ commit }, payload) {
      return ModelosCTeService.PutModelosCTe(payload).then(
        (modelosCTe) => Promise.resolve(modelosCTe),
        (error) => Promise.reject(error.response.data)
      );
    },
    deleteModelosCTe({ commit }, payload) {
      return ModelosCTeService.DeleteModelosCTe(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
    getModelosCTeOData({ commit }, payload) {
      return ModelosCTeService.GetModelosCTeOData(payload).then(
        (modelosCTe) => Promise.resolve(modelosCTe),
        (error) => Promise.reject(error)
      );
    },
  },
  mutations: {},
};

export default modelosCTe;
